import { baseApi } from "../baseApi";
import { getUserEmail } from "../../Localstorage/Localstorage"; 

 const username = getUserEmail();
export const reportApi = baseApi.injectEndpoints({
      endpoints: (builder) => ({
    getFrappeReport: builder.query({
      query: ({ report_name, filters }) => {
        const encodedFilters = encodeURIComponent(JSON.stringify(filters));
        return {
          url: `/api/method/stackerbee_mobile_wms.wms.react_api.run_custom_report?report_name=${report_name}&filters=${encodedFilters}&user=${username}`,
          method: 'GET',
        };
      },
    }),

    getWarehouses: builder.query({
      query: ({ searchTerm = '' }) => {
        const fields = JSON.stringify(["name", "warehouse_type", "company", "creation", "disabled"]);
        const filters = JSON.stringify([
          ["is_group", "=", 0],
          ...(searchTerm ? [["Warehouse", "name", "like", `%${searchTerm}%`]] : [])
        ]);

        return {
          url: `/api/resource/Warehouse?fields=${fields}&filters=${filters}&limit_start=0`,
          method: 'GET',
        };
      },
    }),

    getDynamicResource: builder.query({
      query: ({ resource, searchTerm = '', fields = ["name"] }) => {
        const filters = searchTerm
          ? JSON.stringify([[resource, "name", "like", `%${searchTerm}%`]])
          : JSON.stringify([]);

        return {
          url: `/api/resource/${resource}?fields=${JSON.stringify(fields)}&filters=${filters}&limit_start=0&ignore_prepared_report=false&are_default_filters=true`,
          method: 'GET',
        };
      },
    }),

    getDocTypeResource: builder.query({
      query: ({ docType }) => {
        return {
          url: `/api/resource/${encodeURIComponent(docType)}`,
          method: 'GET',
        };
      },
    }),

    searchFrappeLink: builder.query({
      query: ({ txt, doctype, page_length = 30, reference_doctype = '' }) => {
        const params = new URLSearchParams({
          txt,
          doctype,
          page_length: page_length.toString(),
        });

        if (reference_doctype) {
          params.append('reference_doctype', reference_doctype);
        }

        return {
          url: `/api/method/frappe.desk.search.search_link?${params.toString()}`,
          method: 'GET',
        };
      },
    }),


        searchMaterialRequest: builder.query({
      query: ({ txt = '', page_length = 20 }) => {
        const filters = encodeURIComponent(
          JSON.stringify([
            ["Material Request", "per_received", "<", 100],
            ["Material Request", "material_request_type", "=", "Purchase"]
          ])
        );

        const params = new URLSearchParams({
          txt,
          doctype: "Material Request",
          page_length: page_length.toString(),
          filters
        });

        return {
          url: `/api/method/frappe.desk.search.search_link?${params.toString()}`,
          method: 'GET',
        };
      },
    }),


  }),
});

export const { useGetFrappeReportQuery, useGetWarehousesQuery, useGetDynamicResourceQuery,useGetDocTypeResourceQuery,useSearchFrappeLinkQuery,useLazySearchFrappeLinkQuery,useLazySearchMaterialRequestQuery } = reportApi;


